// GENERATED by scripts/gen-tokens.mjs from design-system-v2/tokens/tokens.css. Do not edit.
// ds-allow-file: canonical generated color data for native brand presets, not component styling.
export const DURATION = { fast: 0.12, base: 0.18, slow: 0.3, enter: 0.4, reveal: 0.45, count: 0.7 } as const
export const EASE = {
  in: [0.4, 0, 1, 1] as [number, number, number, number],
  out: [0.16, 1, 0.3, 1] as [number, number, number, number],
  inOut: [0.4, 0, 0.2, 1] as [number, number, number, number],
  emphasized: [0.22, 1, 0.36, 1] as [number, number, number, number],
} as const
/** The app's own type stacks, for the shell that must re-state them after a tenant override. */
export const FONT_STACKS = {
  '--font-sans': "'Geist', ui-sans-serif, system-ui, sans-serif",
  '--font-display': "'Bricolage Grotesque', ui-sans-serif, system-ui, sans-serif",
  '--font-hero': "'Bricolage Grotesque', ui-sans-serif, system-ui, sans-serif",
} as const
/** Reserved native preset tuple, generated from the current app palette. */
export const APP_BRAND_PALETTE = {
  "primary": "#E4572E",
  "secondary": "#C4441B",
  "tertiary": "#9E3413",
  "neutral": "#EFE9E1"
} as const
/** Native brand families. CSS selects the matching light/dark family. */
export const APP_BRAND_VARS = {
  "--color-primary-50": "#FDF1EB",
  "--color-primary-100": "#FBE7DE",
  "--color-primary-200": "#F6D6C8",
  "--color-primary-300": "#F0B39B",
  "--color-primary-400": "#EA8462",
  "--color-primary-500": "#E4572E",
  "--color-primary-600": "#C4441B",
  "--color-primary-700": "#9E3413",
  "--color-primary-800": "#7A2810",
  "--color-primary-900": "#561C0B",
  "--brand-action-bg-on-light": "#C4441B",
  "--brand-action-bg-hover-on-light": "#9E3413",
  "--brand-action-bg-active-on-light": "#7A2810",
  "--brand-action-text-on-light": "#FFFFFF",
  "--brand-link-on-light": "#9E3413",
  "--brand-link-underline-on-light": "currentColor",
  "--brand-link-decoration-on-light": "underline",
  "--brand-focus-on-light": "#C4441B",
  "--brand-primary-50-on-light": "#FDF1EB",
  "--brand-primary-100-on-light": "#FBE7DE",
  "--brand-primary-200-on-light": "#F6D6C8",
  "--brand-primary-300-on-light": "#F0B39B",
  "--brand-primary-400-on-light": "#EA8462",
  "--brand-primary-500-on-light": "#E4572E",
  "--brand-primary-600-on-light": "#C4441B",
  "--brand-primary-700-on-light": "#9E3413",
  "--brand-primary-800-on-light": "#7A2810",
  "--brand-primary-900-on-light": "#561C0B",
  "--brand-action-bg-on-dark": "#F0B39B",
  "--brand-action-bg-hover-on-dark": "#F3C2AE",
  "--brand-action-bg-active-on-dark": "#EA9A7E",
  "--brand-action-text-on-dark": "#2E1813",
  "--brand-link-on-dark": "#F3C2AE",
  "--brand-link-underline-on-dark": "currentColor",
  "--brand-link-decoration-on-dark": "underline",
  "--brand-focus-on-dark": "#F0B39B",
  "--brand-primary-50-on-dark": "rgba(240, 179, 155, 0.12)",
  "--brand-primary-100-on-dark": "#FBE7DE",
  "--brand-primary-200-on-dark": "#F6D6C8",
  "--brand-primary-300-on-dark": "#F6D6C8",
  "--brand-primary-400-on-dark": "#F3C2AE",
  "--brand-primary-500-on-dark": "#F0B39B",
  "--brand-primary-600-on-dark": "#EA9A7E",
  "--brand-primary-700-on-dark": "#E4805F",
  "--brand-primary-800-on-dark": "#E4572E",
  "--brand-primary-900-on-dark": "#561C0B",
  "--btn-primary-bg": "#C4441B",
  "--btn-primary-bg-hover": "#9E3413",
  "--btn-primary-bg-active": "#7A2810",
  "--btn-primary-text": "#FFFFFF",
  "--action-primary-bg": "#C4441B",
  "--action-primary-bg-hover": "#9E3413",
  "--action-primary-text": "#FFFFFF"
} as const
/** Native flat-theme roles for event/deck surfaces, resolved for each mode. */
export const APP_THEME_VARS = {
  "light": {
    "--color-primary-50": "#FDF1EB",
    "--color-primary-100": "#FBE7DE",
    "--color-primary-200": "#F6D6C8",
    "--color-primary-300": "#F0B39B",
    "--color-primary-400": "#EA8462",
    "--color-primary-500": "#E4572E",
    "--color-primary-600": "#C4441B",
    "--color-primary-700": "#9E3413",
    "--color-primary-800": "#7A2810",
    "--color-primary-900": "#561C0B",
    "--brand-action-bg-on-light": "#C4441B",
    "--brand-action-bg-hover-on-light": "#9E3413",
    "--brand-action-bg-active-on-light": "#7A2810",
    "--brand-action-text-on-light": "#FFFFFF",
    "--brand-link-on-light": "#9E3413",
    "--brand-link-underline-on-light": "currentColor",
    "--brand-link-decoration-on-light": "underline",
    "--brand-focus-on-light": "#C4441B",
    "--brand-primary-50-on-light": "#FDF1EB",
    "--brand-primary-100-on-light": "#FBE7DE",
    "--brand-primary-200-on-light": "#F6D6C8",
    "--brand-primary-300-on-light": "#F0B39B",
    "--brand-primary-400-on-light": "#EA8462",
    "--brand-primary-500-on-light": "#E4572E",
    "--brand-primary-600-on-light": "#C4441B",
    "--brand-primary-700-on-light": "#9E3413",
    "--brand-primary-800-on-light": "#7A2810",
    "--brand-primary-900-on-light": "#561C0B",
    "--brand-action-bg-on-dark": "#F0B39B",
    "--brand-action-bg-hover-on-dark": "#F3C2AE",
    "--brand-action-bg-active-on-dark": "#EA9A7E",
    "--brand-action-text-on-dark": "#2E1813",
    "--brand-link-on-dark": "#F3C2AE",
    "--brand-link-underline-on-dark": "currentColor",
    "--brand-link-decoration-on-dark": "underline",
    "--brand-focus-on-dark": "#F0B39B",
    "--brand-primary-50-on-dark": "rgba(240, 179, 155, 0.12)",
    "--brand-primary-100-on-dark": "#FBE7DE",
    "--brand-primary-200-on-dark": "#F6D6C8",
    "--brand-primary-300-on-dark": "#F6D6C8",
    "--brand-primary-400-on-dark": "#F3C2AE",
    "--brand-primary-500-on-dark": "#F0B39B",
    "--brand-primary-600-on-dark": "#EA9A7E",
    "--brand-primary-700-on-dark": "#E4805F",
    "--brand-primary-800-on-dark": "#E4572E",
    "--brand-primary-900-on-dark": "#561C0B",
    "--btn-primary-bg": "#C4441B",
    "--btn-primary-bg-hover": "#9E3413",
    "--btn-primary-bg-active": "#7A2810",
    "--btn-primary-text": "#FFFFFF",
    "--action-primary-bg": "#C4441B",
    "--action-primary-bg-hover": "#9E3413",
    "--action-primary-text": "#FFFFFF",
    "--surface-page": "#EFE9E1",
    "--surface-default": "#FFFDF9",
    "--surface-muted": "#F7F2EB",
    "--surface-elevated": "#FFFDF9",
    "--card-bg": "#FFFDF9",
    "--input-bg": "#FFFDF9",
    "--text-primary": "#221B26",
    "--text-secondary": "#43394A",
    "--text-muted": "#554B5A",
    "--text-inverted": "#FFFFFF",
    "--border-default": "#E3DACE",
    "--border-strong": "#CFC3B5",
    "--card-border": "#EBE3D8",
    "--input-border": "#E0D6CA",
    "--border-focus": "#C4441B",
    "--focus-ring-color": "#C4441B",
    "--text-link": "#9E3413",
    "--text-link-underline": "currentColor",
    "--text-link-decoration": "underline",
    "--on-success": "#FFFFFF",
    "--surface-brand-subtle": "#FDF1EB",
    "--text-on-brand-subtle": "#9E3413",
    "--color-accent-50": "#F0FDFA",
    "--color-accent-100": "#CCFBF1",
    "--color-accent-400": "#2DD4BF",
    "--color-accent-500": "#14B8A6",
    "--color-accent-600": "#0D9488",
    "--on-accent": "#120D14",
    "--font-display": "'Bricolage Grotesque', ui-sans-serif, system-ui, sans-serif",
    "--font-hero": "'Bricolage Grotesque', ui-sans-serif, system-ui, sans-serif"
  },
  "dark": {
    "--color-primary-50": "rgba(240, 179, 155, 0.12)",
    "--color-primary-100": "#FBE7DE",
    "--color-primary-200": "#F6D6C8",
    "--color-primary-300": "#F6D6C8",
    "--color-primary-400": "#F3C2AE",
    "--color-primary-500": "#F0B39B",
    "--color-primary-600": "#EA9A7E",
    "--color-primary-700": "#E4805F",
    "--color-primary-800": "#E4572E",
    "--color-primary-900": "#561C0B",
    "--brand-action-bg-on-light": "#C4441B",
    "--brand-action-bg-hover-on-light": "#9E3413",
    "--brand-action-bg-active-on-light": "#7A2810",
    "--brand-action-text-on-light": "#FFFFFF",
    "--brand-link-on-light": "#9E3413",
    "--brand-link-underline-on-light": "currentColor",
    "--brand-link-decoration-on-light": "underline",
    "--brand-focus-on-light": "#C4441B",
    "--brand-primary-50-on-light": "#FDF1EB",
    "--brand-primary-100-on-light": "#FBE7DE",
    "--brand-primary-200-on-light": "#F6D6C8",
    "--brand-primary-300-on-light": "#F0B39B",
    "--brand-primary-400-on-light": "#EA8462",
    "--brand-primary-500-on-light": "#E4572E",
    "--brand-primary-600-on-light": "#C4441B",
    "--brand-primary-700-on-light": "#9E3413",
    "--brand-primary-800-on-light": "#7A2810",
    "--brand-primary-900-on-light": "#561C0B",
    "--brand-action-bg-on-dark": "#F0B39B",
    "--brand-action-bg-hover-on-dark": "#F3C2AE",
    "--brand-action-bg-active-on-dark": "#EA9A7E",
    "--brand-action-text-on-dark": "#2E1813",
    "--brand-link-on-dark": "#F3C2AE",
    "--brand-link-underline-on-dark": "currentColor",
    "--brand-link-decoration-on-dark": "underline",
    "--brand-focus-on-dark": "#F0B39B",
    "--brand-primary-50-on-dark": "rgba(240, 179, 155, 0.12)",
    "--brand-primary-100-on-dark": "#FBE7DE",
    "--brand-primary-200-on-dark": "#F6D6C8",
    "--brand-primary-300-on-dark": "#F6D6C8",
    "--brand-primary-400-on-dark": "#F3C2AE",
    "--brand-primary-500-on-dark": "#F0B39B",
    "--brand-primary-600-on-dark": "#EA9A7E",
    "--brand-primary-700-on-dark": "#E4805F",
    "--brand-primary-800-on-dark": "#E4572E",
    "--brand-primary-900-on-dark": "#561C0B",
    "--btn-primary-bg": "#F0B39B",
    "--btn-primary-bg-hover": "#F3C2AE",
    "--btn-primary-bg-active": "#EA9A7E",
    "--btn-primary-text": "#2E1813",
    "--action-primary-bg": "#F0B39B",
    "--action-primary-bg-hover": "#F3C2AE",
    "--action-primary-text": "#2E1813",
    "--surface-page": "#141017",
    "--surface-default": "#1C1620",
    "--surface-muted": "#241D29",
    "--surface-elevated": "#2A2230",
    "--card-bg": "#1C1620",
    "--input-bg": "#17121A",
    "--text-primary": "#F7EFF2",
    "--text-secondary": "#D6CBD9",
    "--text-muted": "#BBAEC0",
    "--text-inverted": "#FFFFFF",
    "--border-default": "#352C3B",
    "--border-strong": "#43384A",
    "--card-border": "#2C2431",
    "--input-border": "#43384A",
    "--border-focus": "#F0B39B",
    "--focus-ring-color": "#F0B39B",
    "--text-link": "#F3C2AE",
    "--text-link-underline": "currentColor",
    "--text-link-decoration": "underline",
    "--on-success": "#FFFFFF",
    "--surface-brand-subtle": "#2E2226",
    "--text-on-brand-subtle": "#F3C2AE",
    "--color-accent-50": "#F0FDFA",
    "--color-accent-100": "#CCFBF1",
    "--color-accent-400": "#2DD4BF",
    "--color-accent-500": "#14B8A6",
    "--color-accent-600": "#0D9488",
    "--on-accent": "#120D14",
    "--font-display": "'Bricolage Grotesque', ui-sans-serif, system-ui, sans-serif",
    "--font-hero": "'Bricolage Grotesque', ui-sans-serif, system-ui, sans-serif"
  }
} as const
